"use strict";
window.theme = window.theme || {}
theme.CollectionFilter = function() {
    function CollectionFilter() {
        this.selector = {
            collection_grid_container: document.getElementById('collection-grid-container')
        }
        this.state = {
            selected_filters: [],
            selected_sort_by: null,
            isDraggingMin: false,
            isDraggingMax: false,
            minPriceRangePreviousValue: 0,
            maxPriceRangePreviousValue: 0,
            priceRangeTimeout: null,
            selectedLimit: null,
            renderRequestId: 0,
            renderController: null
        }
        this.load();
    }
    CollectionFilter.prototype.load = async function() {
        var _ = this;
        if(window.location.pathname.includes('collections')) {
            document.querySelector('html').classList.add('spf-status-loaded');
        }
        const urlParams = new URL(window.location.href);
        const existingParams = new URLSearchParams(urlParams.search);
        let paramsObject = {};
        existingParams.forEach((value,key) => {
            paramsObject[key] = value;
            /* T5.23 (22 May 2026) — Restore filter.p.* (tag, product_type,
               vendor, etc.) into state on page load IN ADDITION to filter.v.*.
               Previously only filter.v.* was restored, which caused a silent
               desync bug: after any full page reload landing on a URL with
               filter.p.tag=Artist:X, the state was empty, so the next AJAX
               filter click would rebuild URL from the empty state and
               silently DROP the Artist:X prefix tag. This was the root cause
               behind multiple "filters disappeared" reports across T5.20–22. */
            if (key.indexOf('filter.v') === 0 || key.indexOf('filter.p.') === 0) {
                _.state.selected_filters.push({filter: `${key}=${value}`, title: `${value}`});
            }
        })
        if(_.selector.collection_grid_container) {
            const initialLimit = document.getElementById('setProductDisplayLimit');
            _.defaultLimit = initialLimit && initialLimit.value ? initialLimit.value : '48';
            const urlLimit = urlParams.searchParams.get('limit');
            _.state.selectedLimit = ['24', '48', '96'].includes(urlLimit) ? urlLimit : _.defaultLimit;
            const sectionWrapper = _.selector.collection_grid_container.closest('[id^="shopify-section-"]');
            const sectionId = sectionWrapper && sectionWrapper.id.slice('shopify-section-'.length);
            const configuredLimit = initialLimit && initialLimit.selectedOptions.length && initialLimit.selectedOptions[0].hasAttribute('selected');
            _.sectionId = configuredLimit && sectionId && sectionId.indexOf('template--') === 0 ? sectionId : null;
            _.pathname = window.location.pathname;
            _.renderedUrl = window.location.pathname + window.location.search;
            window.addEventListener('popstate', function () {
                if (window.location.pathname !== _.pathname) return;
                if (window.location.pathname + window.location.search === _.renderedUrl && !_.state.renderController) return;
                const params = new URLSearchParams(window.location.search);
                _.state.selected_filters = [];
                params.forEach(function (value, key) {
                    if (key.indexOf('filter.v.') === 0 || key.indexOf('filter.p.') === 0) {
                        _.state.selected_filters.push({ filter: key + '=' + value, title: value });
                    }
                });
                _.state.selected_sort_by = params.get('sort_by');
                _.renderfilter({ keepPage: true, fromHistory: true });
            });
            _.state.selected_sort_by = urlParams.searchParams.get('sort_by') ? urlParams.searchParams.get('sort_by') : _.selector.collection_grid_container.dataset.sortBy;
            _.state.minPriceRangePreviousValue = _.selector.collection_grid_container.querySelector('.gf-range-inputs > input.gf-range-min') && parseInt(_.selector.collection_grid_container.querySelector('.gf-range-inputs > input.gf-range-min').value);
            _.state.maxPriceRangePreviousValue = _.selector.collection_grid_container.querySelector('.gf-range-inputs > input.gf-range-max') && parseInt(_.selector.collection_grid_container.querySelector('.gf-range-inputs > input.gf-range-max').value);
            _.selector.collection_grid_container.addEventListener('click', async event => {
                if(event.target.closest('.globo-dropdown-custom__options')) {
                    _.state.selected_sort_by = event.target.closest('span').dataset.sort;
                    event.target.closest('.sort-by') && (event.target.closest('.sort-by').querySelector('.sort-by-toggle > .sort-by-container > span').textContent = event.target.closest('span').textContent);
                    event.target.closest('.sort-by') && (event.target.closest('.sort-by').classList.toggle('active'));  
                    await _.renderfilter();
                } 
                if(event.target.closest('.featured-quick-view-modal-btn')) {
                    event.preventDefault();
                    await theme.QuickView.rendercontent(event.target.closest('.featured-quick-view-modal-btn').dataset.productUrl);                    
                }     
                if(event.target.closest('.sort-by')) {
                    event.target.closest('.sort-by').classList.toggle('active');
                }      
                if(event.target.closest('.gf-block-title') && event.target.closest('.gf-option-block') && !event.target.closest('.filter-category-clear')) {
                    event.target.closest('.gf-option-block') && (event.target.closest('.gf-option-block').classList.toggle('is-collapsed'));
                }
                if(event.target.closest('.filter-fit-option')) {
                    if(event.target.closest('.filter-fit-option').checked) {
                        event.target.closest('label') && (event.target.closest('label').classList.add('checked'));
                        _.state.selected_filters.push({filter: event.target.closest('.filter-fit-option').dataset.filterParam, title: event.target.closest('.filter-fit-option').dataset.filterTitle});
                    } else {
                        _.state.selected_filters = _.state.selected_filters.filter(item => item.title !== event.target.closest('.filter-fit-option').dataset.filterTitle);        
                    }
                    await _.renderfilter();
                }
                if(event.target.closest('.clear-link')) {
                    event.preventDefault();
                    _.state.selected_filters = _.state.selected_filters.filter(item => item.title !== event.target.closest('.clear-link').dataset.fvalue);
                    await _.renderfilter();
                }
                if(event.target.closest('.gf-refine-toggle')) {
                    _.state.selected_filters = [];
                    await _.renderfilter();
                }
                if(event.target.closest('.filter-color-option')) {
                    if(!event.target.closest('.filter-color-option').classList.contains('selected')) {
                        event.target.closest('button') && (event.target.closest('button').classList.add('active'));
                        _.state.selected_filters.push({filter: event.target.closest('button').dataset.filterParam, title: event.target.closest('.filter-color-option').dataset.filterTitle});
                        event.target.closest('.filter-color-option').classList.add('selected');
                    } else {
                        _.state.selected_filters = _.state.selected_filters.filter(item => item.title !== event.target.closest('.filter-color-option').dataset.filterTitle);  
                        event.target.closest('.filter-color-option').classList.remove('selected');
                    }
                    await _.renderfilter();
               }
               if(event.target.closest('.gf-refine-toggle-mobile')) {
                    document.body.classList.toggle('offcanvas-open');
               }
               if(event.target.closest('.gf-close-canvas')) {
                    document.body.classList.toggle('offcanvas-open');
               }
               if(event.target.closest('.clear-refinements')) {
                    _.state.selected_filters = [];
                    await _.renderfilter();
               }
               if(event.target.closest('.gf-option-block-slider')) {
                    event.preventDefault();
               }
               if(event.target.closest('.colour-swatch-label')) {
                    /* Update the tile's cover link so clicking the tile after picking
                       a swatch opens the PDP with that variant pre-selected — not the
                       default variant. Matches component-dynamic-collection.js and
                       component-featured-products.js (which already do this on their
                       respective tile types). Added 2026-05-19 to fix Sage→default
                       issue on collection pages. */
                    var swatchLabel = event.target.closest('.colour-swatch-label');
                    var variantUrl = swatchLabel && swatchLabel.dataset.variantUrl;
                    var cardInner = event.target.closest('.spf-product-card__inner');
                    if (variantUrl && cardInner) {
                        var imageWrapper = cardInner.querySelector('.product-tile__image-container > .spf-product-card__image-wrapper');
                        if (imageWrapper) imageWrapper.href = variantUrl;
                        /* Also update legacy .cover-link if the tile uses that markup. */
                        var coverLink = cardInner.querySelector('.cover-link');
                        if (coverLink) coverLink.href = variantUrl;
                    }
                    /* T5.100b — Swatch images on demand. Cards no longer pre-render
                       a hidden <img> per colour; the swatch label carries the variant
                       image URL (data-variant-image) and we rewrite the main image's
                       src/srcset in place. The hover (secondary) image inherits the
                       previous main image, preserving the old swap behaviour. */
                    var swatchImageUrl = swatchLabel && swatchLabel.dataset.variantImage;
                    var mainImage = cardInner && (cardInner.querySelector('img.spf-product-card__image-main') || cardInner.querySelector('img.spf-product-card__image'));
                    if (swatchImageUrl && mainImage) {
                        try {
                            var imgUrl = new URL(swatchImageUrl, window.location.origin);
                            if (mainImage.currentSrc.indexOf(imgUrl.pathname) === -1) {
                                var hoverImage = cardInner.querySelector('img.spf-product-card__image-secondary');
                                if (hoverImage) {
                                    hoverImage.removeAttribute('data-lkc-hover-src');
                                    hoverImage.removeAttribute('data-lkc-hover-srcset');
                                    if (imageWrapper) imageWrapper.classList.remove('lkc-hover-pending');
                                    hoverImage.src = mainImage.src;
                                    hoverImage.srcset = mainImage.srcset;
                                    hoverImage.dataset.colourHandle = mainImage.dataset.colourHandle || '';
                                }
                                var widths = [260, 400, 520, 800, 1000, 1200, 1600];
                                mainImage.srcset = widths.map(function (w) {
                                    imgUrl.searchParams.set('width', w);
                                    return imgUrl.href + ' ' + w + 'w';
                                }).join(', ');
                                imgUrl.searchParams.set('width', 1600);
                                mainImage.src = imgUrl.href;
                                mainImage.dataset.colourHandle = swatchLabel.dataset.colourValue;
                            }
                        } catch (e) { /* keep the current image if the URL is malformed */ }
                    }
               }
               if(event.target.closest('.filter-category-clear')) {
                    event.preventDefault();
                    _.state.selected_filters = _.state.selected_filters.filter(filter => !filter.filter.includes(event.target.closest('.filter-category-clear').dataset.categoryHandle));
                    await _.renderfilter();
               }
               if(event.target.closest('#pagination')) {
                    const link = event.target.closest('a');
                    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                    if (link.hasAttribute('data-pagination-retry')) return;
                    if (link.closest('#pagination').getAttribute('aria-busy') === 'true') {
                        event.preventDefault();
                        return;
                    }
                    const pageUrl = new URL(link.href, window.location.href);
                    const page = pageUrl.searchParams.get('page') || '1';
                    if (pageUrl.origin !== window.location.origin || pageUrl.pathname !== window.location.pathname || !/^[1-9]\d*$/.test(page)) return;
                    event.preventDefault();
                    document.documentElement.classList.remove('spf-status-loaded');
                    await _.renderfilter({ keepPage: true, page: page, pagination: true, control: link.getAttribute('rel') || 'page' });
               }
            });
            _.selector.collection_grid_container.addEventListener('keyup', event => {
                if(event.target.closest('.gf-range-min')) {
                    if(_.state.priceRangeTimeout) {
                        clearTimeout(_.state.priceRangeTimeout);
                    }
                   _.state.priceRangeTimeout = setTimeout(async () => {
                        event.target.closest('.gf-range-min') && (event.target.closest('.gf-range-min').disabled = true);
                        _.state.selected_filters = _.state.selected_filters.filter(item => !item.filter.includes('filter.v.price.gte'));
                        _.state.selected_filters = _.state.selected_filters.filter(item => !item.filter.includes('filter.v.price.lte'));
                        _.state.selected_filters.push({filter: `filter.v.price.gte=${parseInt(event.target.closest('.gf-range-min').value)}`, title: `Price Range:Min`});
                        _.state.selected_filters.push({filter: `filter.v.price.lte=${parseInt(event.target.closest('.gf-range-inputs').querySelector('.gf-range-max').value)}`, title: `Price Range:Max`});
                        await _.renderfilter();
                        event.target.closest('.gf-range-min') && (event.target.closest('.gf-range-min').disabled = false);
                    },1000);
                }           
                if(event.target.closest('.gf-range-max')) {
                    if(_.state.priceRangeTimeout) {
                        clearTimeout(_.state.priceRangeTimeout);
                    }
                    _.state.priceRangeTimeout = setTimeout(async () => {
                    event.target.closest('.gf-range-max') && (event.target.closest('.gf-range-max').disabled = true);
                    _.state.selected_filters = _.state.selected_filters.filter(item => !item.filter.includes('filter.v.price.gte'));
                    _.state.selected_filters = _.state.selected_filters.filter(item => !item.filter.includes('filter.v.price.lte'));
                    _.state.selected_filters.push({filter: `filter.v.price.gte=${parseInt(event.target.closest('.gf-range-inputs').querySelector('.gf-range-min').value)}`, title: `Price Range:Min`});
                    _.state.selected_filters.push({filter: `filter.v.price.lte=${parseInt(event.target.closest('.gf-range-max').value)}`, title: `Price Range:Max`});
                    await _.renderfilter();
                    event.target.closest('.gf-range-max') && (event.target.closest('.gf-range-max').disabled = false);
                    },1000);
                }              
            });
            _.selector.collection_grid_container.addEventListener('keydown', event => {
                if(event.target.closest('.gf-range-min')) {
                    _.state.minPriceRangePreviousValue = event.target.closest('.gf-range-min').value;                    
                }
                if(event.target.closest('.gf-range-max')) {
                    _.state.maxPriceRangePreviousValue = event.target.closest('.gf-range-max').value;
                }
            });
            _.selector.collection_grid_container.addEventListener('input', event => {
                if(event.target.closest('.gf-range-min')) {
                    if(/^[0-9]*$/.test(event.target.closest('.gf-range-min').value)) {
                        if(event.target.closest('.gf-range-min').value === '') {
                            event.target.closest('.gf-range-min').value = parseInt(_.state.minPriceRangePreviousValue);
                        } else {
                            if(parseInt(event.target.closest('.gf-range-min').dataset.maxValue) > parseInt(event.target.closest('.gf-range-min').value)) {
                                event.target.closest('.gf-range-min').value = parseInt(event.target.closest('.gf-range-min').value); 
                                _.state.minPriceRangePreviousValue = parseInt(event.target.closest('.gf-range-min').value); 
                            } else {
                                event.target.closest('.gf-range-min').value = _.state.minPriceRangePreviousValue; 
                            }
                        }                                        
                    } else {
                        event.target.closest('.gf-range-min').value = parseInt(_.state.minPriceRangePreviousValue);
                    }
                    let minValue = 0;
                    let maxValue = parseInt(event.target.closest('.gf-range-inputs').querySelector('.gf-range-max').dataset.maxValue);
                    let currentValue = parseInt(event.target.closest('.gf-range-min').value);
                    let percentage = ((currentValue - minValue) / (maxValue - minValue)) * 100;
                    event.target.closest('.gf-scroll') && (event.target.closest('.gf-scroll').querySelector('#gf-range-slider-range').style.width = percentage + '%');
                    event.target.closest('.gf-scroll') && (event.target.closest('.gf-scroll').querySelector('#gf-range-slider-handle-min').style.left = `calc(${percentage}% - 10px)`);       
                }
                if(event.target.closest('.gf-range-max')) {
                    if(/^[0-9]*$/.test(event.target.closest('.gf-range-max').value)) {
                        if(event.target.closest('.gf-range-max').value === '') {
                            event.target.closest('.gf-range-max').value = parseInt(_.state.maxPriceRangePreviousValue);
                        } else {
                            const minValue = event.target.closest('.gf-range-inputs').querySelector('.gf-range-min');
                            if(parseInt(event.target.closest('.gf-range-max').dataset.maxValue) >= parseInt(event.target.closest('.gf-range-max').value)) {
                                setTimeout(() => {                                
                                    if(parseInt(event.target.closest('.gf-range-max').value) > parseInt(minValue.value)) {
                                        event.target.closest('.gf-range-max').value = parseInt(event.target.closest('.gf-range-max').value); 
                                        _.state.maxPriceRangePreviousValue = parseInt(event.target.closest('.gf-range-max').value);
                                    } else {
                                        event.target.closest('.gf-range-max').value = parseInt(minValue.value); 
                                        _.state.maxPriceRangePreviousValue = parseInt(minValue.value);
                                    }
                                },2000);                          
                            } else {
                                event.target.closest('.gf-range-max').value = _.state.maxPriceRangePreviousValue; 
                            }
                        }                                        
                    } else {
                        event.target.closest('.gf-range-max').value = parseInt(_.state.maxPriceRangePreviousValue);
                    }
                    let minValue = 0;
                    let maxValue = parseInt(event.target.closest('.gf-range-inputs').querySelector('.gf-range-max').dataset.maxValue);
                    let currentValue = parseInt(event.target.closest('.gf-range-max').value);
                    let percentage = ((currentValue - minValue) / (maxValue - minValue)) * 100;
                    event.target.closest('.gf-scroll') && (event.target.closest('.gf-scroll').querySelector('#gf-range-slider-range').style.width = percentage + '%');
                    event.target.closest('.gf-scroll') && (event.target.closest('.gf-scroll').querySelector('#gf-range-slider-handle-max').style.left = `calc(${percentage}% - 10px)`);                       
                }
            });
            /* T5.37d (27 May 2026) — Price slider mobile-touch fix.
               Was: mousedown / mousemove / mouseup only — those events don't
               fire reliably on touch devices, so the price slider was
               unresponsive on mobile (~78% of LKC traffic). Now uses Pointer
               Events which cover mouse, touch, and pen uniformly (iOS Safari
               13+, all evergreen browsers). setPointerCapture keeps the drag
               tracking even if the finger leaves the handle area mid-drag —
               required for smooth slider UX. */
            _.selector.collection_grid_container.addEventListener('pointerdown', event => {
                if(event.target.closest('#gf-range-slider-handle-min')) {
                    _.state.isDraggingMin = true;
                    /* Capture pointer so subsequent move/up fire on this element
                       even if finger leaves the small 20×20 handle hitbox. */
                    if (event.target.setPointerCapture) {
                        try { event.target.setPointerCapture(event.pointerId); } catch(e) {}
                    }
                    if(_.state.priceRangeTimeout) {
                        clearTimeout(_.state.priceRangeTimeout);
                    }
                   _.state.priceRangeTimeout = setTimeout(async () => {
                        event.target.closest('.gf-scroll').querySelector('.gf-range-min').disabled = true;
                        _.state.selected_filters = _.state.selected_filters.filter(item => !item.filter.includes('filter.v.price.gte'));
                        _.state.selected_filters = _.state.selected_filters.filter(item => !item.filter.includes('filter.v.price.lte'));
                        _.state.selected_filters.push({filter: `filter.v.price.gte=${parseInt(event.target.closest('.gf-scroll').querySelector('.gf-range-min').value)}`, title: `Price Range:Min`});
                        _.state.selected_filters.push({filter: `filter.v.price.lte=${parseInt(event.target.closest('.gf-scroll').querySelector('.gf-range-inputs .gf-range-max').value)}`, title: `Price Range:Max`});
                        await _.renderfilter();
                        event.target.closest('.gf-scroll').querySelector('.gf-range-min').disabled = false;
                    },1000);
                }
                if(event.target.closest('#gf-range-slider-handle-max')) {
                    _.state.isDraggingMax = true;
                    if (event.target.setPointerCapture) {
                        try { event.target.setPointerCapture(event.pointerId); } catch(e) {}
                    }
                    if(_.state.priceRangeTimeout) {
                        clearTimeout(_.state.priceRangeTimeout);
                    }
                    _.state.priceRangeTimeout = setTimeout(async () => {
                    event.target.closest('.gf-scroll') && (event.target.closest('.gf-scroll').querySelector('.gf-range-max').disabled = true);
                    _.state.selected_filters = _.state.selected_filters.filter(item => !item.filter.includes('filter.v.price.gte'));
                    _.state.selected_filters = _.state.selected_filters.filter(item => !item.filter.includes('filter.v.price.lte'));
                    _.state.selected_filters.push({filter: `filter.v.price.gte=${parseInt(event.target.closest('.gf-scroll').querySelector('.gf-range-inputs .gf-range-min').value)}`, title: `Price Range:Min`});
                    _.state.selected_filters.push({filter: `filter.v.price.lte=${parseInt(event.target.closest('.gf-scroll').querySelector('.gf-range-max').value)}`, title: `Price Range:Max`});
                    await _.renderfilter();
                    event.target.closest('.gf-range-max') && (event.target.closest('.gf-range-max').disabled = false);
                    },1000);
                }
            });
            _.selector.collection_grid_container.addEventListener('pointermove', event => {
                if(_.state.isDraggingMin || _.state.isDraggingMax) {
                    /* Block default scroll/zoom during a drag so finger movement
                       acts on the slider, not the page. */
                    event.preventDefault();
                }
                if(_.state.isDraggingMin) {
                    /* T5.37d — Pointer Events fire on the captured element (the
                       handle itself) so closest('#gf-range-slider') would miss.
                       Fall back to document-level lookup. */
                    const slider = _.selector.collection_grid_container.querySelector('#gf-range-slider');
                    if(slider) {
                        const rect = slider.getBoundingClientRect();
                        const sliderWidth = slider.offsetWidth;
                        let position = event.clientX - rect.left;
                        if(position < 0) position = 0;
                        if(position > sliderWidth) position = sliderWidth;
                        _.updateslidermin(position, slider);
                    }
                }
                if(_.state.isDraggingMax) {
                    const slider = _.selector.collection_grid_container.querySelector('#gf-range-slider');
                    if(slider) {
                        const rect = slider.getBoundingClientRect();
                        const sliderWidth = slider.offsetWidth;
                        let position = event.clientX - rect.left;
                        if(position < 0) position = 0;
                        if(position > sliderWidth) position = sliderWidth;
                        _.updateslidermax(position, slider);
                    }
                }
            });
            _.selector.collection_grid_container.addEventListener('pointerup', event => {
                /* T5.37d — Stop tracking on pointerup OR pointercancel (mobile
                   browser can cancel a touch if it decides to scroll instead). */
                _.state.isDraggingMin = false;
                _.state.isDraggingMax = false;
                if (event.target.releasePointerCapture) {
                    try { event.target.releasePointerCapture(event.pointerId); } catch(e) {}
                }
            });
            _.selector.collection_grid_container.addEventListener('pointercancel', event => {
                _.state.isDraggingMin = false;
                _.state.isDraggingMax = false;
            });
            _.selector.collection_grid_container.addEventListener('change', async event => {
                const pageSelect = event.target.closest('#pagination .lkc-pagination__select');
                if (pageSelect) {
                    if (pageSelect.disabled) return;
                    const page = pageSelect.value;
                    const currentPage = new URL(window.location.href).searchParams.get('page') || '1';
                    if (!/^[1-9]\d*$/.test(page) || page === currentPage) return;
                    document.documentElement.classList.remove('spf-status-loaded');
                    await _.renderfilter({ keepPage: true, page: page, pagination: true, control: 'select' });
                }
                if(event.target.closest('#setProductDisplayLimit')) {
                    _.renderfilter({ limit: event.target.closest('#setProductDisplayLimit').value });
                }
            })
        }
    }
    CollectionFilter.prototype.setPaginationState = function(status, page, control, retryUrl) {
        const grid = this.selector.collection_grid_container;
        const pagination = grid.querySelector('#pagination[data-loading-label]');
        let live = document.getElementById('lkc-collection-page-status');
        if (!pagination) {
            if (live && status !== 'loading') live.textContent = '';
            return;
        }
        if (!live) {
            live = document.createElement('p');
            live.id = 'lkc-collection-page-status';
            live.className = 'sr-only';
            live.setAttribute('role', 'status');
            live.setAttribute('aria-live', 'polite');
            live.setAttribute('aria-atomic', 'true');
            grid.before(live);
        }
        const busy = status === 'loading';
        pagination.classList.toggle('is-loading', busy);
        pagination.classList.toggle('has-error', status === 'error');
        if (busy) pagination.setAttribute('aria-busy', 'true');
        else pagination.removeAttribute('aria-busy');
        pagination.querySelectorAll('a:not([data-pagination-retry])').forEach(function (link) {
            if (busy) link.setAttribute('aria-disabled', 'true');
            else link.removeAttribute('aria-disabled');
            const active = control === 'page' ? link.classList.contains('page') && new URL(link.href, window.location.href).searchParams.get('page') === page : link.getAttribute('rel') === control;
            link.classList.toggle('is-loading', busy && active);
        });
        const select = pagination.querySelector('.lkc-pagination__select');
        if (select) {
            select.disabled = busy;
            if (status === 'error') select.value = pagination.dataset.currentPage;
        }
        const feedback = pagination.querySelector('.lkc-pagination__feedback');
        const message = pagination.querySelector('.lkc-pagination__message');
        const retry = pagination.querySelector('[data-pagination-retry]');
        if (feedback) feedback.hidden = status === 'loaded';
        const text = busy ? (page ? pagination.dataset.loadingPage.replace('[page]', page) : pagination.dataset.loadingLabel) : pagination.dataset.loadError;
        if (message) message.textContent = text;
        if (retry) {
            retry.hidden = status !== 'error';
            if (retryUrl) retry.href = retryUrl;
        }
        live.textContent = status === 'loaded' ? pagination.dataset.loadedPage.replace('[page]', pagination.dataset.currentPage) : text;
    }
    CollectionFilter.prototype.renderfilter = async function(opts) {
        var _ = this;
        opts = opts || {};
        if (!_.selector.collection_grid_container) return false;
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const limitEl = document.getElementById('setProductDisplayLimit');
        const defaultLimit = limitEl && limitEl.value ? limitEl.value : _.defaultLimit;
        const requestedLimit = opts.fromHistory ? (params.get('limit') || _.defaultLimit) : (opts.limit || _.state.selectedLimit || params.get('limit') || defaultLimit || '48');
        const limit = ['24', '48', '96'].includes(String(requestedLimit)) ? String(requestedLimit) : '48';
        _.state.selectedLimit = limit;
        Array.from(params.keys()).forEach(function (key) {
            if (key.indexOf('filter.v.') === 0 || key.indexOf('filter.p.') === 0) params.delete(key);
        });
        _.state.selected_filters.forEach(function (item) {
            const separator = item.filter.indexOf('=');
            if (separator === -1) return;
            const key = item.filter.slice(0, separator);
            const value = item.filter.slice(separator + 1);
            if (key.indexOf('filter.v.') === 0 || key.indexOf('filter.p.') === 0) params.append(key, value);
        });
        if (_.state.selected_sort_by) params.set('sort_by', _.state.selected_sort_by);
        else params.delete('sort_by');
        params.set('limit', limit);
        const page = opts.keepPage ? (opts.page || params.get('page')) : null;
        if (page && /^[1-9]\d*$/.test(page)) params.set('page', page);
        else params.delete('page');
        params.delete('section_id');
        const sectionUrl = new URL(url.href);
        const isSearch = /\/search\/?$/.test(url.pathname);
        sectionUrl.searchParams.set('section_id', !isSearch && limit === _.defaultLimit && _.sectionId ? _.sectionId : (isSearch ? 'search-' : 'collection-') + limit);
        const requestId = ++_.state.renderRequestId;
        if (_.state.renderController) _.state.renderController.abort();
        const controller = typeof AbortController === 'function' ? new AbortController() : null;
        _.state.renderController = controller;
        const restorePagerFocus = opts.pagination && document.activeElement && document.activeElement.closest('#pagination') ? opts.control : null;
        _.setPaginationState('loading', opts.keepPage ? (page || '1') : null, opts.control);
        _.selector.collection_grid_container.setAttribute('aria-busy', 'true');
        let requestTimer;
        let timedOut = false;
        try {
            const reading = fetch(sectionUrl.href, controller ? { signal: controller.signal } : {}).then(async function (response) {
                if (requestId !== _.state.renderRequestId) return '';
                if (!response.ok) throw new Error('Collection request failed: ' + response.status);
                return response.text();
            });
            const deadline = new Promise(function (resolve, reject) {
                requestTimer = setTimeout(function () {
                    timedOut = true;
                    reject(new Error('Collection request timed out'));
                    if (controller) controller.abort();
                }, 20000);
            });
            const html = await Promise.race([reading, deadline]);
            if (requestId !== _.state.renderRequestId || (controller && controller.signal.aborted)) return false;
            const htmlDoc = new DOMParser().parseFromString(html, 'text/html');
            const collectionGrid = htmlDoc.getElementById('collection-grid-container');
            if (!collectionGrid || !collectionGrid.querySelector('#gf-products')) throw new Error('Collection section was not returned');
            const mobileChips = _.selector.collection_grid_container.querySelector('.collection-chip-row-wrap--mobile');
            _.selector.collection_grid_container.innerHTML = collectionGrid.innerHTML;
            if (mobileChips && !_.selector.collection_grid_container.querySelector('.collection-chip-row-wrap--mobile')) {
                const mobileTitle = _.selector.collection_grid_container.querySelector('.lkc-mobile-inline-title');
                if (mobileTitle) mobileTitle.after(mobileChips);
                else _.selector.collection_grid_container.querySelector('#gf-products').before(mobileChips);
            }
            const renderedLimit = _.selector.collection_grid_container.querySelector('#setProductDisplayLimit');
            if (renderedLimit) renderedLimit.value = limit;
            if (collectionGrid.dataset.sortBy) {
                _.selector.collection_grid_container.dataset.sortBy = collectionGrid.dataset.sortBy;
                _.state.selected_sort_by = collectionGrid.dataset.sortBy;
            }
            if (!opts.fromHistory && url.href !== window.location.href) {
                window.history.pushState({}, document.title, url.href);
            }
            _.renderedUrl = window.location.pathname + window.location.search;
            _.setPaginationState('loaded');
            if (restorePagerFocus && document.activeElement === document.body) {
                const pagination = _.selector.collection_grid_container.querySelector('#pagination');
                const focusTarget = pagination && (restorePagerFocus === 'select' ? pagination.querySelector('.lkc-pagination__select') : pagination.querySelector('a[rel="' + restorePagerFocus + '"]'));
                if (focusTarget || pagination) (focusTarget || pagination).focus({ preventScroll: true });
            }
            if (!opts.fromHistory) {
                requestAnimationFrame(function () {
                    if (requestId !== _.state.renderRequestId) return;
                    const rect = _.selector.collection_grid_container.getBoundingClientRect();
                    const gridTopAbs = rect.top + window.scrollY;
                    if (window.scrollY > gridTopAbs) {
                        _.selector.collection_grid_container.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            }
            return true;
        } catch (error) {
            if (requestId !== _.state.renderRequestId || (controller && controller.signal.aborted && !timedOut)) return false;
            console.error('Fetch request failed:', error);
            _.setPaginationState('error', null, null, url.href);
            if (!opts.pagination || !_.selector.collection_grid_container.querySelector('[data-pagination-retry]')) window.location.assign(url.href);
            return false;
        } finally {
            clearTimeout(requestTimer);
            if (requestId === _.state.renderRequestId) {
                _.state.renderController = null;
                _.selector.collection_grid_container.removeAttribute('aria-busy');
                document.documentElement.classList.add('spf-status-loaded');
            }
        }
    }

    /* T5.25 (22 May 2026) — renderfilterAND removed. See revert note in
       renderfilter() above. */

    CollectionFilter.prototype.updateslidermin = function(position, target) {
        var _ = this;
        const gfScroll = target.closest('.gf-scroll');
        const sliderWidth = target.offsetWidth;
        const percentage = (position / sliderWidth) * 100;
        if(gfScroll) {
            const maxRange = parseFloat(gfScroll.querySelector('.gf-range-inputs > .gf-range-max').value);
            const minRange =  (percentage / 100) * maxRange;           
            const gapRange = maxRange - 10;
            if(gapRange > minRange) {               
                gfScroll.querySelector('.gf-range-inputs > .gf-range-min').value = parseFloat(minRange.toFixed(0));
                target.querySelector('#gf-range-slider-range').style.width = percentage + '%';
                target.querySelector('#gf-range-slider-handle-min').style.left = `calc(${percentage}% - 10px)`;
            }    
        }
    }
    CollectionFilter.prototype.updateslidermax = function(position, target) {
        var _ = this;
        const gfScroll = target.closest('.gf-scroll');
        const sliderWidth = target.offsetWidth;
        const percentage = (position / sliderWidth) * 100;   
        if(gfScroll) {
            const maxRange = parseFloat(gfScroll.querySelector('.gf-range-inputs > .gf-range-max').dataset.maxValue);
            const minRange = parseFloat(gfScroll.querySelector('.gf-range-inputs > .gf-range-min').value);
            let rangeValue = maxRange * percentage; 
            rangeValue = rangeValue / 100;            
            const gapRange = minRange + 10;
            if(gapRange < rangeValue) {   
                gfScroll.querySelector('.gf-range-inputs > .gf-range-max').value = parseFloat(rangeValue.toFixed(0));            
                target.querySelector('#gf-range-slider-range').style.width = percentage + '%';
                target.querySelector('#gf-range-slider-handle-max').style.left = `calc(${percentage}% - 10px)`;
            }    
        }          
    }
    theme.CollectionFilter = new CollectionFilter;
}
theme.CollectionFilter();

/* ─────────────────────────────────────────────────────────────────────
   T5.8 v2 (21 May 2026) — Client-side Collection filter.

   The previous version attached listeners directly to checkbox elements
   at DOMContentLoaded. But the existing filter system does a full AJAX
   re-render of #collection-grid-container.innerHTML on every other
   filter change (see CollectionFilter.prototype.renderfilter at line 346
   of this same file). That wipes every element my listeners were bound
   to, so the COLLECTION checkboxes silently stopped working as soon as
   the user clicked any other filter.

   v2 fix: document-level event delegation. The listeners live on
   `document`, which survives any innerHTML replacement. State is
   restored from sessionStorage after every AJAX render via a
   MutationObserver on the (stable) #collection-grid-container element.

   Behaviour unchanged from v1:
     - Multi-select with OR semantics
     - State persists in sessionStorage across filter changes
     - "Clear all" buttons also wipe our state
     - Filter re-applies after load-more / AJAX refresh
   ───────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var STORAGE_KEY = 'lkc_collection_filter_selected';

  function readStoredSelection() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? raw.split(',').filter(Boolean) : [];
    } catch (e) { return []; }
  }
  function writeStoredSelection(handles) {
    try {
      if (handles.length === 0) sessionStorage.removeItem(STORAGE_KEY);
      else sessionStorage.setItem(STORAGE_KEY, handles.join(','));
    } catch (e) { /* noop */ }
  }
  function clearStoredSelection() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
  }

  function getCheckboxes() {
    return document.querySelectorAll('.gf-collection-client-filter');
  }
  function getSelectedHandles() {
    var checkboxes = getCheckboxes();
    var selected = [];
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) selected.push(checkboxes[i].dataset.collectionHandle);
    }
    return selected;
  }
  function applyFilter() {
    var productGrid = document.getElementById('gf-products');
    if (!productGrid) return;
    var selected = getSelectedHandles();
    var tiles = productGrid.querySelectorAll('[data-product-collections]');
    if (selected.length === 0) {
      for (var j = 0; j < tiles.length; j++) {
        if (tiles[j].style.display) tiles[j].style.display = '';
      }
      hideEmptyMessage();
      return;
    }
    var visibleCount = 0;
    for (var k = 0; k < tiles.length; k++) {
      var tile = tiles[k];
      var tileCollections = (tile.getAttribute('data-product-collections') || '').split(' ');
      var matches = false;
      for (var m = 0; m < selected.length; m++) {
        if (tileCollections.indexOf(selected[m]) !== -1) { matches = true; break; }
      }
      var display = matches ? '' : 'none';
      if (tile.style.display !== display) tile.style.display = display;
      if (matches) visibleCount++;
    }
    /* T5.13 — when filter produces 0 visible products, show an empty
       state with a "Clear collection filter" button so users aren't
       stranded with what looks like a broken page. */
    if (visibleCount === 0) {
      showEmptyMessage();
    } else {
      hideEmptyMessage();
    }
  }

  /* T5.14 (21 May 2026) — inject "Collection: X" chips into the Filter By
     header so users can see + remove their collection selections the same
     way they remove server-side filter selections.

     My collection filter is client-side, so the Liquid chip loop in
     collection-gf-tree.liquid doesn't know about it. This function adds/
     removes chips manually based on the current selection state, and the
     click handler below removes a chip + unchecks its checkbox. */
  function updateCollectionChips() {
    var wrapper = document.querySelector('.globo-selected-items-wrapper');
    var container = document.querySelector('.globo-selected-items');
    if (!container) return;

    /* Wipe any existing collection chips from previous renders */
    var stale = container.querySelectorAll('.lkc-collection-chip');
    for (var i = 0; i < stale.length; i++) {
      stale[i].parentNode.removeChild(stale[i]);
    }

    var selected = getSelectedHandles();
    for (var j = 0; j < selected.length; j++) {
      var handle = selected[j];
      var cb = document.querySelector('.gf-collection-client-filter[data-collection-handle="' + handle + '"]');
      if (!cb) continue;
      /* Grab the human-readable label from the corresponding sidebar entry */
      var labelEl = cb.parentNode ? cb.parentNode.querySelector('.gf-label') : null;
      var title = labelEl ? labelEl.textContent.trim() : handle;

      var chip = document.createElement('div');
      chip.className = 'selected-item gf-option-label lkc-collection-chip';
      chip.setAttribute('data-collection-handle', handle);
      /* T5.15 — match the server-rendered chip structure exactly so the
         existing `.clear-link` CSS (padding-left/right, layout, X position)
         applies identically. The capture-phase click handler below uses
         the `.lkc-collection-chip` outer class to identify our chips
         specifically without affecting normal server chips. */
      chip.innerHTML =
        '<span data-fid="collection-' + handle + '" data-fvalue="collection-' + handle + '" class="clear-link">' +
        '<span class="selected-item">' +
        '<span class="hidden-xs">Collection</span>' +
        '<strong><span class="gf-label">' + title.replace(/[<>&]/g, function (c) {
          return c === '<' ? '&lt;' : c === '>' ? '&gt;' : '&amp;';
        }) + '</span></strong>' +
        '</span>' +
        '<span class="gf-clear"></span>' +
        '</span>';
      container.appendChild(chip);
    }

    /* Show the wrapper if we have any chips (server- or client-side) */
    if (wrapper) {
      var hasAnyChip = container.querySelector('.selected-item.gf-option-label');
      if (hasAnyChip) wrapper.classList.add('active');
    }
  }

  /* Click handler for collection chip removal. Uses capture phase so we
     intercept BEFORE the existing .clear-link delegated handler tries to
     fire its AJAX flow on our chip. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var chip = e.target.closest('.lkc-collection-chip');
    if (!chip) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = chip.getAttribute('data-collection-handle');
    var cb = document.querySelector('.gf-collection-client-filter[data-collection-handle="' + handle + '"]');
    if (cb) cb.checked = false;
    writeStoredSelection(getSelectedHandles());
    applyFilter();
    updateCollectionChips();
  }, true);

  /* T5.13 — empty state shown when collection filter yields 0 visible tiles */
  function showEmptyMessage() {
    var productGrid = document.getElementById('gf-products');
    if (!productGrid) return;
    if (document.getElementById('lkc-collection-empty-state')) return;
    var msg = document.createElement('div');
    msg.id = 'lkc-collection-empty-state';
    msg.style.cssText =
      'grid-column: 1 / -1;' +
      'flex: 0 0 100%;' +
      'width: 100%;' +
      'padding: 60px 24px;' +
      'margin: 20px 0;' +
      'text-align: center;' +
      'background: #fff;' +
      'border: 2px solid #000;' +
      'box-sizing: border-box;';
    msg.innerHTML =
      '<p style="margin:0 0 8px;font-size:18px;font-weight:700;text-transform:uppercase;letter-spacing:1px;">No matches in this combination</p>' +
      '<p style="margin:0 0 24px;font-size:14px;color:#666;">No products in this collection match the collection filter you have selected.</p>' +
      '<button type="button" id="lkc-collection-empty-clear" style="background:#000;color:#fff;border:none;padding:14px 28px;font-weight:700;font-size:13px;text-transform:uppercase;letter-spacing:1px;cursor:pointer;border-radius:4px;font-family:inherit;">Clear collection filter</button>';
    productGrid.appendChild(msg);
    var btn = document.getElementById('lkc-collection-empty-clear');
    if (btn) {
      btn.addEventListener('click', function () {
        var cbs = getCheckboxes();
        for (var i = 0; i < cbs.length; i++) cbs[i].checked = false;
        clearStoredSelection();
        applyFilter();
      });
    }
  }
  function hideEmptyMessage() {
    var el = document.getElementById('lkc-collection-empty-state');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function restoreSelection() {
    var stored = readStoredSelection();
    if (!stored.length) return;
    var checkboxes = getCheckboxes();

    /* T5.13 — only restore checkboxes whose collection actually has
       matching products on the CURRENT page. Without this, a selection
       saved on /collections/all (where every collection has products)
       persists onto /collections/australiana — and if Bundles has zero
       overlap with Australiana, the filter immediately hides every
       tile and the user sees an empty page. */
    var productGrid = document.getElementById('gf-products');
    var availableHandles = {};
    if (productGrid) {
      var tiles = productGrid.querySelectorAll('[data-product-collections]');
      for (var t = 0; t < tiles.length; t++) {
        var handles = (tiles[t].getAttribute('data-product-collections') || '').split(' ');
        for (var h = 0; h < handles.length; h++) {
          if (handles[h]) availableHandles[handles[h]] = true;
        }
      }
    }

    var restoredAny = [];
    for (var i = 0; i < checkboxes.length; i++) {
      var handle = checkboxes[i].dataset.collectionHandle;
      if (stored.indexOf(handle) !== -1 && availableHandles[handle]) {
        checkboxes[i].checked = true;
        restoredAny.push(handle);
      }
    }
    /* Prune invalid handles from sessionStorage so they don't keep
       returning on later page loads where they're also invalid. */
    if (restoredAny.length !== stored.length) {
      writeStoredSelection(restoredAny);
    }
  }

  /* T5.11 (21 May 2026) — Cross-filter Collection count + visibility update.

     After other filters narrow the visible product set (Size, Colour,
     Product Type, etc.), the Collection list should:
       - Show a count that reflects ONLY the products passing those other
         filters (not the Shopify-rendered total products_count, which
         counts ALL products in the collection regardless of filters)
       - Hide collections with zero matching products (so the list shows
         only collections the user could meaningfully select)
       - Keep currently-checked collections visible even if they hit zero
         matches, so the user can still uncheck them

     The count we compute = number of tiles in #gf-products whose
     data-product-collections attribute contains the collection handle,
     IGNORING any client-side hide via the collection filter itself
     (otherwise count would change as the user toggles, which is wrong
     for OR semantics). The result: counts mean "products that would
     match if you ADD this collection to your selection". */
  /* T5.19 (22 May 2026) — gutted updateCollectionCounts().

     Previously this counted how many tiles in #gf-products were tagged
     with each collection handle, and overwrote the (count) text with
     that number, plus hid zero-count entries.

     But #gf-products only contains ONE PAGE of products (48 tiles via
     pagination). On a large collection like /collections/t-shirts (600+
     products), counting only the 48 visible tiles produced wildly low
     numbers — e.g. "Birds (17)" when the actual T-shirts × Birds
     intersection across all pages was much higher. User-reported as the
     headline issue: the counts were misleading.

     Computing the true intersection requires server-side data we don't
     have without expensive additional fetches. Removed counts entirely
     from the Liquid (see snippets/collection-gf-tree.liquid). This
     function is now a no-op; left in place so the call sites below
     don't error. The empty-state card on zero matches (T5.13) still
     covers the case where a user picks a collection with no overlap. */
  function updateCollectionCounts() {
    /* intentional no-op — see comment above */
  }

  /* Document-level delegation — survives AJAX re-renders */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('gf-collection-client-filter')) {
      writeStoredSelection(getSelectedHandles());
      applyFilter();
      updateCollectionChips();
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    /* Clear button INSIDE the COLLECTION section */
    var ownClear = e.target.closest('[data-category-handle="collection-client-filter"]');
    if (ownClear) {
      var cbs = getCheckboxes();
      for (var i = 0; i < cbs.length; i++) cbs[i].checked = false;
      clearStoredSelection();
      applyFilter();
      updateCollectionChips();
      return;
    }
    /* Global "Clear All" buttons — wipe our state so it doesn't survive */
    if (e.target.closest('.gf-refine-toggle, .clear-refinements')) {
      clearStoredSelection();
    }
  });

  /* MutationObserver on the (stable) grid container — fires when the AJAX
     render replaces its innerHTML AND when load-more appends new tiles
     inside #gf-products. subtree:true catches both; debouncing keeps the
     callback cost down if many mutations fire in a single burst.

     T5.11: also calls updateCollectionCounts() so the Collection list
     reflects the currently-rendered tile set after any DOM change. */
  function attachObserver() {
    var container = document.getElementById('collection-grid-container');
    if (!container || typeof MutationObserver === 'undefined') return;

    /* T5.18 (22 May 2026) — debounce reduced from 60ms to 0 (microtask).
       The 60ms delay was opening a visible "flash of unfiltered tiles"
       between the AJAX innerHTML swap and applyFilter() hiding tiles
       again. During that 60ms gap the spf-product-card::before rainbow-
       hover borders (component-base.css:5332-5345) showed up as broken
       outline lines where tiles should be. Running on a microtask (0ms)
       keeps the observer batching benefit (many DOM mutations in one
       burst still coalesce into a single callback) while eliminating
       the visible flash. */
    var debounceTimer = null;
    var observer = new MutationObserver(onMutate);
    function onMutate(records) {
      var changedProducts = records.some(function (record) {
        var nodes = Array.from(record.addedNodes).concat(Array.from(record.removedNodes));
        return nodes.some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-product-collections], .gf-collection-client-filter') || node.querySelector('[data-product-collections], .gf-collection-client-filter'));
        });
      });
      if (!changedProducts) return;
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        observer.disconnect();
        try {
          restoreSelection();
          applyFilter();
          updateCollectionCounts();
          updateCollectionChips();
        } finally {
          observer.observe(container, { childList: true, subtree: true });
        }
      }, 0);
    }

    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    restoreSelection();
    applyFilter();
    updateCollectionCounts();
    updateCollectionChips();
    attachObserver();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────────────
   T5.13 (21 May 2026) — Scroll expanded filter section into view.

   When the sidebar is at its bottom-of-page position (sticky has
   unsticked because .collection-body has ended) and the user clicks
   a collapsed filter section (e.g. PRICE — which is now the LAST item
   per T5.10's reorder), the expanded content opens BELOW the viewport.
   To the user this looks like the click did nothing.

   This handler runs AFTER the existing toggle (which lives in the
   delegated click handler at line ~61 of this file). It checks if the
   newly-expanded section's bottom is below the viewport, and if so,
   smooth-scrolls just enough to bring the expanded content into view.
   ───────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  /* T5.18 (22 May 2026) — TWO new gates on top of the original logic:

     1. Skip on desktop entirely (>=1024px). Desktop has a sticky sidebar
        that effectively keeps the filter pinned; nearly every expanded
        section's bottom is below viewportH-20 because the sidebar is
        tall and sticky. The original handler was therefore firing a
        smooth-scroll on EVERY filter click on desktop — the "bouncing"
        the user reported.

     2. Only scroll when the user EXPANDED a closed section, not when
        they collapsed an open one. We capture is-collapsed state BEFORE
        the existing toggle runs (this listener fires in the bubble
        phase after the document-level toggle handler at line ~61
        already ran, so we read post-toggle state then invert).
     ----------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    /* Skip on desktop — sticky sidebar makes this scroll counterproductive */
    if ((window.innerWidth || document.documentElement.clientWidth) >= 1024) return;
    var title = e.target.closest('.gf-block-title');
    if (!title) return;
    /* Don't scroll on clear-button clicks — those shouldn't expand/collapse */
    if (e.target.closest('.filter-category-clear') || e.target.closest('.gf-clear')) return;
    var block = title.closest('.gf-option-block');
    if (!block) return;

    /* Defer to next frame so the existing toggle handler has run and the
       block's new height is laid out before we measure. */
    requestAnimationFrame(function () {
      /* Only scroll if the section is now EXPANDED (not collapsed) */
      if (block.classList.contains('is-collapsed')) return;
      var rect = block.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom > viewportH - 20) {
        block.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    });
  });
})();

/* T5.15 (21 May 2026) — Removed the IntersectionObserver that previously
   toggled the floating bar's visibility based on scroll position. The
   bar is now always visible on mobile (CSS display:block in the
   ≤63.99875em media query), so no JS is needed to manage its state. */

/* T5.25 (22 May 2026) — Removed the T5.23 visual-mask + on-load AND trigger.
   With cross-prefix AND no longer attempted, there's no need for the
   client-side tile-hiding mask or the on-load renderfilter() invocation.
   Multiple filter.p.tag values now natively OR-combine via Shopify's
   storefront filtering, which is the standard Shopify behaviour. */
   
